// This stub has the intention to be used during the e2e tests to
// avoid the interaction with the MS authentication server.
// Unfortunately I was not able to stub the MSAL via Cypress.
export default class msalTestStub {
  static install(Vue) {
    Vue.prototype.$msal = new msalTestStub();
  }
  constructor() {
    const exposed = {
      data: null,
      signIn() {},
      signOut() {},
      isAuthenticated() {
        return true;
      },
      async acquireToken() {
        return true;
      }
    };
    return exposed;
  }
}
